import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SplunkLogEventType, SplunkLogStatement } from '../model/splunk-log-statement';
import { AuthenticatedHttpService } from './authenticatedhttp.service';

@Injectable()
export class SplunkLogService {
    private baseUrl;

    constructor(
        private _http: AuthenticatedHttpService
    ) { 
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    public log(splunkLogStatement: SplunkLogStatement): Observable<SplunkLogStatement> {
        return this._http
            .post(this.baseUrl + '/api/log', JSON.stringify(splunkLogStatement))
            .map(x => {
                let res = new SplunkLogStatement();
                res = this.mapSplunkLogStatement(x.json());
                return res;
            })
            .catch((error: any) => Observable.throw(error.json().error));
    }

    private mapSplunkLogStatement(apiSplunkLogStatement: any): SplunkLogStatement
    {
        if (apiSplunkLogStatement !== undefined && apiSplunkLogStatement !== null) {
            let res: SplunkLogStatement = new SplunkLogStatement();
            res.SetEventForResult(apiSplunkLogStatement.SplunkReportEvent, apiSplunkLogStatement.EventDateTime);
            res.SetUser(apiSplunkLogStatement.UserId, apiSplunkLogStatement.UserName, apiSplunkLogStatement.UserType);
            res.SetRetailerForResult(apiSplunkLogStatement.RetailerNumber, apiSplunkLogStatement.RetailerName, apiSplunkLogStatement.RetailerType);
            res.SetQuote(apiSplunkLogStatement.QuoteId, apiSplunkLogStatement.ModelId, apiSplunkLogStatement.ModelDescription, apiSplunkLogStatement.Plan);
            return res;
        } else {
            return undefined;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/splunk-log.service.ts